var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMenuSelectedPathway = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 39.54 39.44",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 19.77,
    y1: 39.22,
    x2: 19.77,
    y2: 0.22,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b9c49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#49a845"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#83c03e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9aca3c"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M19.77,39.22C9.02,39.22,.27,30.47,.27,19.72S9.02,.22,19.77,.22s19.5,8.75,19.5,19.5-8.75,19.5-19.5,19.5Z",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.44,12.2h2.33c.39,0,.77,.09,1.13,.26,1.92,.93,7.91,4.24,3.96,7.83-2.46,2.24-2.75,3.45-1.85,4.58,.22,.27,.02,.67-.33,.67H13.23c-.26,0-.46-.23-.41-.49,.29-1.5,1.34-4.03,5.08-5.07,0,0,4.41-1.37,3.24-4.06-.41-.94-1.45-1.79-2.95-2.96-.31-.24-.15-.75,.25-.75Z",
    style: {
      fill: "#fff"
    }
  }));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMenuSelectedPathway, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Menu_Selected_Pathway.e024c41f.svg";
export { ForwardRef as ReactComponent };